var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _path9, _path0, _path1, _rect3, _rect4, _circle, _circle2, _circle3, _circle4, _circle5, _line, _line2, _line3, _line4, _line5, _line6, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountMetricScoreNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.074 32.9302L119.35 49.1683H136.424L122.611 59.204L127.887 75.4421L114.074 65.4064L100.261 75.4421L105.537 59.204L91.7244 49.1683H108.798L114.074 32.9302Z",
    fill: "#F58120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.074 32.9302L169.35 49.1683H186.424L172.611 59.204L177.887 75.4421L164.074 65.4064L150.261 75.4421L155.537 59.204L141.724 49.1683H158.798L164.074 32.9302Z",
    fill: "#F58120"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.074 32.9302L219.35 49.1683H236.424L222.611 59.204L227.887 75.4421L214.074 65.4064L200.261 75.4421L205.537 59.204L191.724 49.1683H208.798L214.074 32.9302Z",
    fill: "#F58120"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.074 32.9302L269.35 49.1683H286.424L272.611 59.204L277.887 75.4421L264.074 65.4064L250.261 75.4421L255.537 59.204L241.724 49.1683H258.798L264.074 32.9302Z",
    fill: "#F58120"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.074 37.1662L111.399 50.4773L111.624 51.1683H112.35H126.346L115.023 59.395L114.436 59.822L114.66 60.513L118.985 73.824L107.662 65.5974L107.074 65.1703L106.486 65.5974L95.1634 73.824L99.4884 60.513L99.7129 59.822L99.1251 59.395L87.8021 51.1683H101.798H102.525L102.749 50.4773L107.074 37.1662Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.074 37.1662L161.399 50.4773L161.624 51.1683H162.35H176.346L165.023 59.395L164.436 59.822L164.66 60.513L168.985 73.824L157.662 65.5974L157.074 65.1703L156.486 65.5974L145.163 73.824L149.488 60.513L149.713 59.822L149.125 59.395L137.802 51.1683H151.798H152.525L152.749 50.4773L157.074 37.1662Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M207.074 37.1662L211.399 50.4773L211.624 51.1683H212.35H226.346L215.023 59.395L214.436 59.822L214.66 60.513L218.985 73.824L207.662 65.5974L207.074 65.1703L206.486 65.5974L195.163 73.824L199.488 60.513L199.713 59.822L199.125 59.395L187.802 51.1683H201.798H202.525L202.749 50.4773L207.074 37.1662Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.074 37.1662L261.399 50.4773L261.624 51.1683H262.35H276.346L265.023 59.395L264.436 59.822L264.66 60.513L268.985 73.824L257.662 65.5974L257.074 65.1703L256.486 65.5974L245.163 73.824L249.488 60.513L249.713 59.822L249.125 59.395L237.802 51.1683H251.798H252.525L252.749 50.4773L257.074 37.1662Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.5742,
    y: 96.9302,
    width: 26,
    height: 204,
    fill: "#528FF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5742,
    y: 106.93,
    width: 27,
    height: 202,
    stroke: "#192657",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5742 257.93H79.5742",
    stroke: "#192657",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5742 207.93H79.5742",
    stroke: "#192657",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5742 157.93H79.5742",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.574,
    y: 106.93,
    width: 198,
    height: 202,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126.574,
    y: 127.93,
    width: 160,
    height: 29,
    rx: 14.5,
    stroke: "#F58120",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 167.574,
    cy: 143.93,
    r: 9,
    fill: "#528FF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.574,
    cy: 143.93,
    r: 9,
    fill: "#528FF5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.574,
    cy: 143.93,
    r: 9,
    fill: "#528FF5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.574,
    cy: 206.93,
    r: 23,
    fill: "#F58120"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.574,
    cy: 266.93,
    r: 23,
    fill: "#F58120"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 198.574,
    y1: 197.93,
    x2: 280.574,
    y2: 197.93,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 198.574,
    y1: 207.93,
    x2: 280.574,
    y2: 207.93,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 198.574,
    y1: 217.93,
    x2: 256.574,
    y2: 217.93,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 198.574,
    y1: 255.93,
    x2: 280.574,
    y2: 255.93,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 198.574,
    y1: 265.93,
    x2: 280.574,
    y2: 265.93,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 198.574,
    y1: 275.93,
    x2: 256.574,
    y2: 275.93,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.574 206.43L152.074 217.43C157.574 208.93 171.374 191.43 174.574 189.43",
    stroke: "#192657",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.574 266.43L152.074 277.43C157.574 268.93 171.374 251.43 174.574 249.43",
    stroke: "#192657",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5745 65.4304C150.408 9.59706 304.374 -53.7696 337.574 139.43C379.074 380.93 45.5745 420.93 14.5745 198.93C8.57447 128.597 47.0745 18.2306 249.074 139.43",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMetricScoreNew);
export default __webpack_public_path__ + "static/media/AccountMetricScoreNew.6761d6822f6f885f4cd1a320d8980236.svg";
export { ForwardRef as ReactComponent };